import api from './api';

// Super-admin platform stats (Admin page)

export interface SiteStatsDay {
  day: string;
  views: number;
  uniques: number;
}

export interface SiteStats {
  days: number;
  totalViews: number;
  uniqueVisitors: number;
  viewsToday: number;
  viewsByDay: SiteStatsDay[];
  topPages: { path: string; views: number; uniques: number }[];
  topReferrers: { referrer: string; views: number }[];
}

export interface PlatformStats {
  companies: { total: number; billed: number; newLast30Days: number };
  users: { total: number; active: number; newLast30Days: number; activeLast30Days: number };
  gateways: { total: number; active: number };
  devices: { total: number; online: number; offline: number; deployed: number };
}

export async function getSiteStats(days = 30): Promise<SiteStats> {
  const response = await api.get<SiteStats>('/admin/stats/site', { params: { days } });
  return response.data;
}

export async function getPlatformStats(): Promise<PlatformStats> {
  const response = await api.get<PlatformStats>('/admin/stats/platform');
  return response.data;
}
